export const PLATFORMS = [
    'shopify',
    'sfcc',
    'buyquickly',
    'predictspring',
    // In-store retail (RP) tooling: booking-tool, check-in, check-out,
    // customer-profile, customer-search. Used inside stores, not customer-facing.
    'instore',
    'tailor-instructions',
    // Customer-facing pages with no host storefront platform — reached directly
    // (e.g. an email link), not embedded in Shopify/SFCC/instore tooling. First
    // user: rp-nps-page (RP-4608).
    'standalone',
];
export const ENVIRONMENTS = ['prd', 'tst', 'acc', 'dev'];
/**
 * Tag keys that the package owns and writes to Datadog's global context.
 *
 * `additionalTags` callers cannot reuse these keys — `validateConfig` rejects
 * them so consumer-supplied values can never overwrite the validated config
 * and skew dashboards or alerts.
 */
export const RESERVED_TAG_KEYS = ['platform', 'env', 'country', 'domain', 'sub_service'];
